/*
 * @author : Augusto Monteiro
 * @email  : augustomna2010@gmail.com
 * @augustomna2010 
 */


Greenmile.Components = Greenmile.Components || {};

//Function/1 for create singletons of components
Greenmile.Components.getInstance = function (component) {
    if (Greenmile.Components[component]) {
        if (typeof Greenmile.Components[component] === "function") {
            Greenmile.Components[component] = new Greenmile.Components[component];
            return Greenmile.Components[component];
        }
        return Greenmile.Components[component];
    } else {
        console.error("Error Component(" + component + ") doesn't exists", this);
    }
};
